/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreatePlanForDoka360ProjectCommandParam } from '../models/create-plan-for-doka-360-project-command-param';
import { PlansModel } from '../models/plans-model';
import { UpdatePlanForDoka360ProjectCommandParam } from '../models/update-plan-for-doka-360-project-command-param';

@Injectable({ providedIn: 'root' })
export class ExternalCustomerPlatformApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPlanForCustomerPlatformProject()` */
  static readonly CreatePlanForCustomerPlatformProjectPath = '/api/v1/externalcustomerplatform/{customerPlatformProjectsUid}/plans';

  /**
   * Create plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanForCustomerPlatformProject$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanForCustomerPlatformProject$Plain$Response(
    params: {
      customerPlatformProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, ExternalCustomerPlatformApiClient.CreatePlanForCustomerPlatformProjectPath, 'post');
    if (params) {
      rb.path('customerPlatformProjectsUid', params.customerPlatformProjectsUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Create plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanForCustomerPlatformProject$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanForCustomerPlatformProject$Plain(
    params: {
      customerPlatformProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.createPlanForCustomerPlatformProject$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /**
   * Create plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanForCustomerPlatformProject()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanForCustomerPlatformProject$Response(
    params: {
      customerPlatformProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, ExternalCustomerPlatformApiClient.CreatePlanForCustomerPlatformProjectPath, 'post');
    if (params) {
      rb.path('customerPlatformProjectsUid', params.customerPlatformProjectsUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Create plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanForCustomerPlatformProject$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanForCustomerPlatformProject(
    params: {
      customerPlatformProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.createPlanForCustomerPlatformProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /** Path part for operation `updatePlanForCustomerPlatformProject()` */
  static readonly UpdatePlanForCustomerPlatformProjectPath = '/api/v1/externalcustomerplatform/{customerPlatformProjectsUid}/plans/{engHubPlanUid}';

  /**
   * Update plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanForCustomerPlatformProject$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanForCustomerPlatformProject$Plain$Response(
    params: {
      customerPlatformProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, ExternalCustomerPlatformApiClient.UpdatePlanForCustomerPlatformProjectPath, 'patch');
    if (params) {
      rb.path('customerPlatformProjectsUid', params.customerPlatformProjectsUid, {});
      rb.path('engHubPlanUid', params.engHubPlanUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Update plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanForCustomerPlatformProject$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanForCustomerPlatformProject$Plain(
    params: {
      customerPlatformProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.updatePlanForCustomerPlatformProject$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /**
   * Update plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanForCustomerPlatformProject()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanForCustomerPlatformProject$Response(
    params: {
      customerPlatformProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, ExternalCustomerPlatformApiClient.UpdatePlanForCustomerPlatformProjectPath, 'patch');
    if (params) {
      rb.path('customerPlatformProjectsUid', params.customerPlatformProjectsUid, {});
      rb.path('engHubPlanUid', params.engHubPlanUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Update plan for CustomerPlatformProject.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanForCustomerPlatformProject$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanForCustomerPlatformProject(
    params: {
      customerPlatformProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.updatePlanForCustomerPlatformProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

}
